import type { Feature } from '@app/hooks/useFeatureState';

import type { ProjectState } from '../../../../../store/project/reducers';
import { ProjectType } from '../../../../../types/project';

type ToolbarVisibility = {
    disabled: boolean;
    visible: boolean;
};

type ToolbarVisibilityMap = {
    upload: ToolbarVisibility;
    download: ToolbarVisibility;
    apps: ToolbarVisibility;
    contentManagement: ToolbarVisibility;
    editor: ToolbarVisibility;
    files: ToolbarVisibility;
    tasks: ToolbarVisibility;
    workflows: ToolbarVisibility;
    contributors: ToolbarVisibility;
    screenshots: ToolbarVisibility;
    glossary: ToolbarVisibility;
    more: ToolbarVisibility;
    settings: ToolbarVisibility;
    branches: ToolbarVisibility;
    otaBundles: ToolbarVisibility;
    automations: ToolbarVisibility;
    duplicateFinder: ToolbarVisibility;
    activity: ToolbarVisibility;
    statistics: ToolbarVisibility;
};

export const getProjectNavigationVisibilityMap = (
    project: ProjectState,
    isFeatureEnabled: (key: Feature) => boolean,
): ToolbarVisibilityMap => ({
    upload: {
        visible: project.projectRights.upload,
        disabled: false,
    },
    download: {
        visible: project.projectRights.download,
        disabled: false,
    },
    // TODO: HOME-1009, Clean up after permission management
    //  -- There is a plan for "Install apps" permission. Right..?
    apps: {
        visible: true,
        disabled: false,
    },
    // TODO: HOME-1009, Clean up after permission management
    //  -- There is a plan for "Install apps" permission. Right..?
    contentManagement: {
        visible: project.type === ProjectType.contentIntegration && project.projectRights.manageKeys,
        disabled: false,
    },
    editor: {
        visible: true,
        disabled: false,
    },
    files: {
        visible:
            isFeatureEnabled('lionLfcFilesManagement') &&
            +project.type === +ProjectType.pagedDocuments &&
            (project.projectRights.upload || project.projectRights.download),
        disabled: false,
    },
    tasks: {
        visible: project.projectRights.tasks,
        disabled: false,
    },
    contributors: {
        visible: project.projectRights.contributors,
        disabled: false,
    },
    workflows: {
        visible: project.projectRights.settings,
        disabled: false,
    },
    screenshots: {
        visible: project.projectRights.screenshots,
        disabled: false,
    },
    glossary: {
        visible: true,
        disabled: false,
    },
    more: {
        visible: true,
        disabled: false,
    },
    settings: {
        visible: project.projectRights.settings,
        disabled: false,
    },
    branches: {
        visible:
            project.isBranchingEnabled && (project.projectRights.createBranches || project.projectRights.mergeBranches),
        disabled: false,
    },
    otaBundles: {
        visible:
            (project.projectRights.download || project.projectRights.settings || project.projectRights.manageKeys) &&
            project.type === ProjectType.localizationFiles,
        disabled: false,
    },
    automations: {
        visible: project.projectRights.settings,
        disabled: false,
    },
    duplicateFinder: {
        visible: project.projectRights.manageKeys && project.type === ProjectType.localizationFiles,
        disabled: false,
    },
    activity: {
        visible: project.offlineTranslation || project.projectRights.activity,
        disabled: false,
    },
    statistics: {
        visible: project.projectRights.statistics,
        disabled: false,
    },
});

export default getProjectNavigationVisibilityMap;
